import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';
import { STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/structured-content-fields';

export const COPY_SHARED_MESSAGE = gql`
    mutation copySharedMessage($data: CopySharedMessageInput!) {
        copySharedMessage(data: $data) {
            message {
                id
                clientRequestId
                parentMessageId
                referencedMessageId
                threadRootMessageId
                email { subject from receivedAt preview hasOriginalHtml }
                laneKind
                title
                body
                createdAt
                updatedAt
                deletedAt
                image {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    width
                    height
                    aspect_ratio
                    duration
                    public_id
                }
                file {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    mime
                    width
                    height
                    aspect_ratio
                    duration
                }
                isCheckbox
                isChecked
                isStarred
                metadata {
                    sharedCopy {
                        sourceOwnerId
                        sourceFolderId
                        sourceMessageId
                        copiedAt
                        referencedOriginal
                    }
                    savedFrom {
                        channel
                        source
                        method
                        type
                        device
                        deviceVersion
                        browser
                        browserVersion
                        appVersion
                        platform
                    }
                }
                folder {
                    ...FolderCacheSafeFields
                }
                urlMeta {
                    author
                    date
                    description
                    image
                    image_cdn_url
                    logo
                    publisher
                    title
                    url
                }
                caption
                keywords
                ocrText
                suggestedFolderTitle
                ${STRUCTURED_CONTENT_FIELDS}
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;
